import { render, staticRenderFns } from "./vText.vue?vue&type=template&id=590ca576&scoped=true&"
import script from "./vText.vue?vue&type=script&lang=js&"
export * from "./vText.vue?vue&type=script&lang=js&"
import style0 from "./vText.vue?vue&type=style&index=0&id=590ca576&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ca576",
  null
  
)

export default component.exports